import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { getDimensions } from '../selectors/sdmx';
import { getMicrodataRequestArgs } from '../selectors/microdata';
import { FLUSH_MICRODATA, PARSE_MICRODATA } from '../ducks/microdata';
import { MICRODATA } from '../utils/constants';
import useSdmxQuery from './sdmx/useSdmxQuery';
import useDeepCompareEffect from 'use-deep-compare-effect';

const handleMicrodata = dispatch => ({ data = {}, queryKey = [] } = {}) => {
  dispatch({
    type: PARSE_MICRODATA,
    datatype: MICRODATA,
    data,
    queryKey,
  });
};

export default () => {
  const dispatch = useDispatch();
  const dispatchHandleMicrodata = handleMicrodata(dispatch);

  const dimensions = useSelector(getDimensions);
  const requestArgs = useSelector(getMicrodataRequestArgs);

  const ctx = { method: 'getMicrodata', requestArgs };

  const successHandler = ({ data, queryKey }) => {
    dispatchHandleMicrodata({ data, queryKey });
  };

  const query = useSdmxQuery(ctx, {
    beforeHook: () => dispatch({ type: FLUSH_MICRODATA }),
    successHandler,
    isEnabled: !R.all(R.isEmpty)(dimensions),
  });

  useDeepCompareEffect(() => {
    if (query.isSuccess && query.data && query.isEnabled) {
      dispatchHandleMicrodata({ data: query.data, queryKey: query.queryKey });
    }
  }, [query]);

  return query;
};
